module.exports = __webpack_public_path__ + "static/img/far2.dcaa7fff.png";